import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import styled from '@emotion/styled';
import { Box, List, ListItem, ListIcon, Stack } from '@chakra-ui/core';

const TextWrapper = styled.div`
    margin: 0rem auto;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const WordName = styled.em`
    font-style: italic;
`;

// const DataList = styled.ul`
//   font-style: italic;
//   list-style-type: square;
//   `;

// const Data = styled.li`
//   font-style: italic;
//   `;

const PrivacyPage = () => (
    <Layout>
        <SEO title="Privacy" />
        <TextWrapper>
            <Box fontSize="3xl" align="center">
                Privacy policy
            </Box>
            <Stack spacing="20px" marginTop="20px" spacing="10px">
                <Box>
                    Local Lingo is published by Manta Software Pty Ltd ("Manta Software", "we"). We care about your personal data, your
                    privacy is important to us.
                </Box>

                <Box>
                    Data is collected from our users to help us build the best set of translations for different languages and different
                    countries.
                </Box>

                <Box>
                    By using the App, you agree to the terms of this Privacy Policy. We may update the policy from occasionally, but you
                    will be informed before any changes come into effect.
                </Box>
                <Box>Information we collect:</Box>
                <List stylePos="outside" spacing="20px" marginTop="20px">
                    <ListItem stylePos="outside">
                        <Stack direction="row">
                            <ListIcon icon="lock" color="#00FF00" />
                            <Box>
                                We keep nothing about you, all details stored are anonymous. Your account is just a number and some
                                settings.
                            </Box>
                        </Stack>
                    </ListItem>
                    <ListItem stylePos="outside">
                        <Stack direction="row">
                            <ListIcon icon="lock" color="#00FF00" />
                            <Box>We store your profiles, we use this to work out which languages and options are most popular.</Box>
                        </Stack>
                    </ListItem>
                    <ListItem stylePos="outside">
                        <Stack direction="row">
                            <ListIcon icon="lock" color="#00FF00" />
                            <Box>
                                If you agree to provide it, we use your location to help work out the best set of translations for each part
                                of the world.{' '}
                            </Box>
                        </Stack>
                    </ListItem>
                    <ListItem stylePos="outside">
                        <Stack direction="row">
                            <ListIcon icon="lock" color="#00FF00" />
                            <Box>
                                The results of your lessons and tests are stored, these let us know which words are easiest and which are
                                hardest.
                            </Box>
                        </Stack>
                    </ListItem>
                    <ListItem stylePos="outside">
                        <Stack direction="row">
                            <ListIcon icon="lock" color="#00FF00" />
                            <Box>
                                The set of words that you love or dislike are kept, these let us know which words are appreciated most by
                                our users.
                            </Box>
                        </Stack>
                    </ListItem>
                    <ListItem stylePos="outside">
                        <Stack direction="row">
                            <ListIcon icon="lock" color="#00FF00" />
                            <Box>Of course, we keep any suggestions you make - this is how we make things better!</Box>
                        </Stack>{' '}
                    </ListItem>
                    <ListItem stylePos="outside">
                        <Stack direction="row">
                            <ListIcon icon="lock" color="#00FF00" />
                            <Box>
                                If you email us, any correspondance will be kept private and your email address will only be retained so
                                that we can respond. We will not share your details with any third party nor will we send any unsolicited
                                messages other than to answer your questions.
                            </Box>
                        </Stack>
                    </ListItem>
                </List>
            </Stack>
        </TextWrapper>
    </Layout>
);

export default PrivacyPage;
